import React from "react";
import { connect } from "react-redux";
import Summary from "./summary";
import { onEdit } from "../actions";
import { getStaffById, getStaffDirectory } from "../utils";

const mapStateToProps = (state) => ({
	person: getStaffById(state),
	profile: state.profile,
	organisations: state.organisations.data,
	staffList: getStaffDirectory(state.staff),
	organisationId:
		state.organisations?.currentOrganisation?.id ||
		state.organisations?.currentOrganisation ||
		"",
});

const mapDispatchToProps = {
	onEdit,
};

const ConnectedSummary = connect(mapStateToProps, mapDispatchToProps)(Summary);

const SummaryContainer = (props) => <ConnectedSummary {...props} />;

export default SummaryContainer;
